<template>
    <iframe :src="route" :key="route" class="iframe-full" />
</template>

<script setup>
const props = defineProps(['route'])
</script>

<style scoped>
.iframe-full {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
    background-color: white;
}
</style>
